
export const etlRoutes = {
    list: 'etls/',
};
